import { Icon } from '@adobe/react-spectrum';

const MaximizeIcon = props => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || '16'}
        height={props.height || '16'}
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M7.22432 8.77539C6.98995 8.54102 6.61026 8.54102 6.37588 8.77539L2.8001 12.3512V10.4055C2.8001 10.0742 2.53135 9.80547 2.2001 9.80547C1.86885 9.80547 1.6001 10.0742 1.6001 10.4055V13.7996C1.6001 14.1309 1.86885 14.3996 2.2001 14.3996H5.59424C5.92549 14.3996 6.19424 14.1309 6.19424 13.7996C6.19424 13.4684 5.92549 13.1996 5.59424 13.1996H3.64854L7.22432 9.62383C7.4587 9.38946 7.4587 9.00977 7.22432 8.77539Z"
          fill="currentColor"
        />
        <path
          d="M14.4001 2.19961V5.59375C14.4001 5.925 14.1313 6.19375 13.8001 6.19375C13.4688 6.19375 13.2001 5.925 13.2001 5.59375V3.64805L9.62431 7.22383C9.50713 7.34102 9.35361 7.39962 9.2001 7.39962C9.04658 7.39962 8.89306 7.34103 8.77588 7.22383C8.5415 6.98946 8.5415 6.60977 8.77588 6.37539L12.3517 2.79961H10.406C10.0747 2.79961 9.80596 2.53086 9.80596 2.19961C9.80596 1.86836 10.0747 1.59961 10.406 1.59961H13.8001C14.1314 1.59961 14.4001 1.86836 14.4001 2.19961Z"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
};

export default MaximizeIcon;
